import React, { useState } from 'react';
import { Form, Button, Card, Container, Row, Col, Image } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const { email, password } = formData;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const success = await login(formData);
    
    if (success) {
      navigate('/');
    }
    
    setLoading(false);
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={6} lg={5}>
          <Card className="shadow">
            <Card.Body className="p-4">
              <div className="text-center mb-4">
                <Image 
                  src={logo} 
                  alt="Logo" 
                  style={{ 
                    width: '200px', 
                    height: 'auto',
                    marginBottom: '1rem'
                  }} 
                />
                <h2 className="mb-3">iReminder Giriş</h2>
              </div>
              <Form onSubmit={handleSubmit} className="auth-form">
                <Form.Group className="mb-3">
                  <Form.Label>E-posta</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={email}
                    onChange={handleChange}
                    placeholder="E-posta adresinizi giriniz"
                    required
                    autoFocus
                    autoComplete="off"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Şifre</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    value={password}
                    onChange={handleChange}
                    placeholder="Şifrenizi giriniz"
                    required
                    autoComplete="off"
                  />
                </Form.Group>

                <Button 
                  variant="primary" 
                  type="submit" 
                  className="w-100 mt-3" 
                  disabled={loading}
                >
                  {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
          <Link to="/register" className="auth-link">
            Hesabınız yok mu? Kayıt olun
          </Link>
          <Link to="/forgot-password" className="auth-link" style={{ marginTop: 8, display: 'block', textAlign: 'center' }}>
            Şifremi unuttum
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
